import axios from 'axios'
import Config from '@/components/Config.vue'
import {saveLogToLocal} from '@/utils'


const tsApiUrl = Config.tsApiUrl
const appService = axios.create({
    baseURL: tsApiUrl,
    timeout: 10000,
    withCredentials: true,
    headers:{
        'userId':localStorage.getItem('oguGuid')
    }

})
//请求拦截器
appService.interceptors.request.use(config=>{
    // config.url = '/api/openApi/'+config.url.substr(5)
    let token = localStorage.getItem('tsToken')
    if(token){
        config.headers['tsToken'] = token
    }
    let userId = (!location.pathname.startsWith('/main'))?localStorage.getItem('tsUserGuid'):localStorage.getItem('oguGuid')
    if(userId){
        config.headers['userId'] = userId
    }
    config.headers['apiTime'] = new Date().getTime()
    config.headers['APPID'] = (!location.pathname.startsWith('/main'))?'TS-APP':'TS'
    saveLogToLocal('tsHttp',{url:config.url,headers:config.headers,params:config.params})
    return config
},error=>{
    saveLogToLocal('tsHttp_error',error)
    return Promise.reject(error)
})
//响应拦截器
appService.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        //响应错误处理
        if(error.response){
            //请求已经发出，但是服务器响应状态码不在2xx范围内
            return Promise.reject(error.response.data);
        } else if(error.request) {
            //请求已经发出，但是没有收到响应
            return Promise.reject("请求错误，没有收到响应！");
        } else {
            //在设置请求时触发了错误，发生未知错误
            return Promise.reject("请求错误：发生未知错误！");
        }
    }
)

export default appService;